import { createSelector } from 'reselect'
import getValueReduxUtil from 'modules/redux/utils/get-value/index.js'
import { getCurrentWorkoutSelect } from '@gymaholic/packages'
import { WORKOUT_KEY } from 'modules/training/models/workout/constants/index.js'

const getProfilesWhoStartedWorkoutSelect = createSelector(
  getCurrentWorkoutSelect,
  (value) => {
    return (
      getValueReduxUtil(value, WORKOUT_KEY.PROFILES_WHO_STARTED) || []
    )
  }
)

export default getProfilesWhoStartedWorkoutSelect
